// Container
const DefaultContainer = () => import('@/containers/DefaultContainer')
// Other Components

// Management
const ManageBlogList = () => import('@/modules/blogs/views/management/ManageBlogList')
const ManageBlogDetail = () => import('@/modules/blogs/views/management/ManageBlogDetail')
const BlogList = () => import('@/modules/blogs/views/BlogList')
const BlogDetail = () => import('@/modules/blogs/views/BlogDetail')

var routes = [
    {
		path: '/blog',
		redirect: '/blog/manage/list',
		component: DefaultContainer,
		children: [
			{
				path: 'manage/list',
				name: 'ManageBlogList',
				component: ManageBlogList,
				meta: {
					requiresAuth: true,
				},
			},
			{
				path: 'manage/add',
				name: 'ManageBlogAdd',
				component: ManageBlogDetail,
				meta: {
					requiresAuth: true,
				},
			},
			{
                path: 'manage/:blog_id',
                name: 'ManageBlogDetail',
                component: ManageBlogDetail,
				meta: {
					requiresAuth: true,
				},
            },
			{
				path: 'list',
				name: 'BlogList',
				component: BlogList,
				meta: {
					requiresAuth: true,
				},
			},
			{
				path: 'detail/:blog_id',
				name: 'BlogDetail',
				component: BlogDetail,
				meta: {
					requiresAuth: true,
				},
			},

		]
	},
];

export default routes;
